var _circle, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentSharingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 116,
    viewBox: "0 0 131 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 58,
    r: 58,
    fill: "#EBAB4B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.91461,
    y: 52.6548,
    width: 119.117,
    height: 63.3217,
    fill: "url(#pattern0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.1267 8.40734C93.1267 9.1847 92.4958 9.81469 91.7174 9.81469C90.9389 9.81469 90.308 9.1847 90.308 8.40734C90.308 7.62998 90.9389 7 91.7174 7C92.4958 7 93.1267 7.63287 93.1267 8.40734Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81875 84.7679C3.81875 85.5453 3.18786 86.1753 2.40937 86.1753C1.63089 86.1753 1 85.5453 1 84.7679C1 83.9905 1.63089 83.3606 2.40937 83.3606C3.18786 83.3606 3.81875 83.9905 3.81875 84.7679Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.678 67.7064C129.678 68.4838 129.048 69.1138 128.269 69.1138C127.491 69.1138 126.86 68.4838 126.86 67.7064C126.86 66.9291 127.491 66.2991 128.269 66.2991C129.05 66.302 129.678 66.932 129.678 67.7064Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8559 10.7452H47.4401",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.942 30.8323H106.4",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17804 40.9034H15.7156",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.136 47.1367C121.536 47.1367 123.483 45.1934 123.483 42.7962C123.483 40.399 121.536 38.4557 119.136 38.4557C116.735 38.4557 114.789 40.399 114.789 42.7962C114.789 45.1934 116.735 47.1367 119.136 47.1367Z",
    fill: "#DC587D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.612 41.6808C120.256 41.3311 119.686 41.3398 119.335 41.6953L119.107 41.9293L118.869 41.6982C118.513 41.3485 117.943 41.3543 117.593 41.7068C117.243 42.0623 117.249 42.6316 117.602 42.9812L118.479 43.8453C118.482 43.8482 118.482 43.8482 118.485 43.8511C118.623 43.9869 118.797 44.0707 118.977 44.0967C119.254 44.1401 119.547 44.0534 119.758 43.8366L120.62 42.9581C120.973 42.5969 120.968 42.0276 120.612 41.6808Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4814 26.432C35.2365 23.2074 33.2309 19.982 30.0016 19.228C26.7723 18.4739 23.5423 20.4766 22.7871 23.7012C22.032 26.9259 24.0376 30.1512 27.2669 30.9053C30.4962 31.6594 33.7262 29.6566 34.4814 26.432Z",
    fill: "#DC587D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6788 23.5268C30.1868 23.0471 29.3996 23.0529 28.9192 23.5441L28.6009 23.8678L28.2739 23.547C27.7848 23.0644 26.9947 23.0702 26.5114 23.5615C26.0281 24.0499 26.0339 24.8388 26.5259 25.3214L27.7385 26.512C27.7414 26.5149 27.7414 26.5178 27.7443 26.5206C27.9382 26.7085 28.1755 26.8241 28.4244 26.8616C28.8064 26.9194 29.2115 26.801 29.5038 26.5033L30.6961 25.2896C31.1794 24.7925 31.1708 24.0065 30.6788 23.5268Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.792 24.362H105.384C104.678 24.362 104.105 23.7898 104.105 23.0847V17.3687C104.105 16.6636 104.678 16.0914 105.384 16.0914H114.792C115.498 16.0914 116.071 16.6636 116.071 17.3687V23.0847C116.071 23.7898 115.498 24.362 114.792 24.362Z",
    fill: "#3963DA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.913 23.4691L109.594 25.8705C109.835 26.2115 110.341 26.2086 110.575 25.8676L112.225 23.4691H107.913Z",
    fill: "#3963DA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.665 22.0588C109.771 22.0732 108.865 22.0848 108.043 22.0299C107.783 22.0126 107.557 21.5993 107.876 21.4693C107.742 21.3999 107.606 21.3363 107.548 21.1861C107.494 21.0445 107.56 20.8537 107.708 20.8162C107.398 20.8942 107.274 20.4 107.517 20.2411C107.389 20.1313 107.282 19.9868 107.256 19.8221C107.23 19.6574 107.297 19.4695 107.444 19.3886C107.54 19.3366 107.656 19.3337 107.766 19.3337C108.139 19.3308 108.509 19.3279 108.883 19.325C108.781 18.7442 108.752 18.1113 109.048 17.5998C109.137 17.4466 109.377 17.2617 109.566 17.3802C109.745 17.49 109.693 17.7674 109.684 17.9408C109.647 18.6633 110.06 19.3915 110.7 19.7325C110.697 19.7325 110.654 21.2728 110.665 22.0588Z",
    fill: "#FBFBFB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.989 22.0576H112.34V19.7342H110.989V22.0576Z",
    fill: "#FBFBFB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2281 71.625H8.16592C7.2601 71.625 6.52502 70.891 6.52502 69.9865V62.6579C6.52502 61.7534 7.2601 61.0193 8.16592 61.0193H20.2281C21.1339 61.0193 21.869 61.7534 21.869 62.6579V69.9865C21.8661 70.8939 21.1339 71.625 20.2281 71.625Z",
    fill: "#3963DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4103 70.4806L13.5634 73.5583C13.8702 73.9946 14.5184 73.9946 14.8223 73.5525L16.9378 70.4777H11.4103V70.4806Z",
    fill: "#3963DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9382 68.6746C13.7922 68.6948 12.6288 68.7092 11.5754 68.637C11.2425 68.6139 10.9531 68.085 11.3583 67.9174C11.1876 67.8307 11.0139 67.7469 10.9416 67.5533C10.8721 67.3712 10.956 67.1256 11.1442 67.0794C10.7477 67.1776 10.5885 66.5476 10.9011 66.3425C10.7361 66.2038 10.6001 66.0188 10.5654 65.805C10.5306 65.5911 10.6174 65.3513 10.8084 65.2501C10.9329 65.1837 11.0805 65.1808 11.2223 65.1779C11.6998 65.175 12.1773 65.1721 12.6548 65.1663C12.5246 64.4207 12.487 63.6087 12.8661 62.9527C12.9789 62.7562 13.2886 62.5192 13.5317 62.6695C13.7603 62.8111 13.6967 63.1666 13.6851 63.3891C13.6388 64.3167 14.1655 65.2501 14.9874 65.6865C14.9787 65.6923 14.9237 67.666 14.9382 68.6746Z",
    fill: "#FBFBFB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3531 68.6702H17.0866V65.6908H15.3531V68.6702Z",
    fill: "#FBFBFB"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0637 115.831H34.6605C32.8634 115.831 31.4048 114.374 31.4048 112.58V42.1027C31.4048 40.3081 32.8634 38.8517 34.6605 38.8517H97.0637C98.8608 38.8517 100.319 40.3081 100.319 42.1027V112.58C100.319 114.374 98.8608 115.831 97.0637 115.831Z",
    fill: "#2F80ED"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8235 104.43C48.0826 103.705 46.8932 103.717 46.1697 104.459L45.6922 104.948L45.2002 104.465C44.4622 103.737 43.2728 103.748 42.5464 104.485C41.82 105.222 41.8287 106.41 42.5666 107.135L44.3927 108.93C44.3956 108.933 44.3985 108.938 44.4043 108.941C44.6966 109.227 45.0555 109.398 45.4317 109.456C46.0105 109.545 46.6211 109.363 47.061 108.915L48.8582 107.083C49.5759 106.343 49.5643 105.156 48.8235 104.43Z",
    fill: "#DC587D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8797 108.756H61.4666C61.2235 108.756 61.0267 108.56 61.0267 108.317V104.586C61.0267 104.344 61.2235 104.147 61.4666 104.147H67.8797C68.1228 104.147 68.3196 104.344 68.3196 104.586V108.317C68.3196 108.56 68.1228 108.756 67.8797 108.756Z",
    fill: "#8994C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8474 105.731H66.1466",
    stroke: "#F9F8FF",
    strokeWidth: 1.1502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8457 106.965H64.2782",
    stroke: "#F9F8FF",
    strokeWidth: 1.1502,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6694 108.253V109.863C66.6694 109.909 66.6144 109.938 66.5767 109.906L64.4931 108.251H66.6694V108.253Z",
    fill: "#8994C8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0212 43.7874H36.3571V98.9714H95.0212V43.7874Z",
    fill: "#6EE1FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4054 74.7019C78.4054 74.7019 83.9146 76.1732 88.2509 89.8893L77.2203 95.8236L74.8969 87.8497L78.4054 74.7019Z",
    fill: "#E0E0E0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6759 74.7831C54.6759 74.7831 50.1843 76.1756 45.848 89.8893L55.866 95.8235L58.1894 87.8497L54.6759 74.7831Z",
    fill: "#E0E0E0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9163 71.7224L55.1305 74.5714C53.6695 75.1053 52.849 76.6577 53.2334 78.1634L58.9495 100.685H74.2672L79.5473 77.1252C79.7813 76.0771 79.2196 75.0167 78.2217 74.6182L70.6749 71.619L62.9163 71.7224Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4194 90.7208L54.6257 83.6524",
    stroke: "#1F120B",
    strokeWidth: 1.0769,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1664 92.2092L77.9626 83.9254",
    stroke: "#1F120B",
    strokeWidth: 1.0769,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9174 71.7225L59.5123 72.9698L66.931 77.6666L73.8002 72.8616L70.676 71.6191L62.9174 71.7225Z",
    fill: "#D39563"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3867 58.4839C78.7092 55.9153 78.4628 56.3754 76.1837 51.2678C74.8212 48.217 73.7692 46.9918 73.1409 46.4973C73.1409 46.4973 70.8372 44.0222 66.7176 44.0222C62.7853 44.0222 60.5063 46.3743 60.5063 46.3743C59.91 46.7729 58.7865 47.9243 57.2934 51.2678C55.0144 56.3754 54.768 55.9153 54.0904 58.4839C53.4129 61.0524 54.2752 65.7885 59.5749 66.7111C59.5749 66.7111 58.8974 66.0345 58.651 64.9274C58.651 64.9274 60.8685 67.9412 63.8891 67.7567H69.5929C72.6112 67.9412 74.8311 64.9274 74.8311 64.9274C74.5847 66.0345 73.9071 66.7111 73.9071 66.7111C79.2019 65.7885 80.0643 61.0524 79.3867 58.4839Z",
    fill: "#13223D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.675 71.6191L69.7313 63.4116C69.7313 63.4116 68.7581 64.4031 67.4671 64.6417C66.176 64.8804 64.9244 64.1275 64.9096 64.1177C64.8948 64.1079 63.8551 63.2443 63.8551 63.2443L62.9163 71.72C62.9163 71.8135 62.8473 72.5737 62.8326 72.6623L70.6972 71.8553C70.6824 71.7815 70.675 71.7003 70.675 71.6191Z",
    fill: "#D39563"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2605 63.5394C63.2605 63.5394 65.239 67.3528 67.5919 66.8067C70.0508 66.2359 70.0385 63.0129 70.0385 63.0129L63.2605 63.5394Z",
    fill: "#1C2238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2051 52.5812C75.2051 57.2509 71.566 61.0373 67.0768 61.0373C62.5877 61.0373 58.9486 57.2509 58.9486 52.5812C58.9486 47.9116 62.5877 44.7354 67.0768 44.7354C71.566 44.7354 75.2051 47.9116 75.2051 52.5812Z",
    fill: "#1C2238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7948 53.0169C73.7948 55.9274 73.3883 58.4394 72.9842 60.2231C72.5876 61.9699 71.4714 63.1877 69.897 64.1694L69.6088 64.349C67.9408 65.3872 65.7849 65.4118 64.0922 64.4105C62.3848 63.4018 61.1873 62.0683 60.8202 60.196C60.1501 56.7885 60.0786 53.0144 60.0786 53.0144C60.0786 53.0144 59.4429 45.6655 66.8394 45.8082C74.2359 45.9509 73.7948 53.0169 73.7948 53.0169Z",
    fill: "#D39563"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8839 59.9178C59.5805 61.0422 56.8358 56.5915 58.0973 55.3909C59.3587 54.1903 60.2531 56.1438 60.2531 56.1438L60.5094 57.551L60.8913 59.443L60.9898 59.8686L60.8839 59.9178Z",
    fill: "#D39563"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6639 56.8916C58.6639 56.8916 59.1961 55.7378 60.4379 57.7626",
    stroke: "#1C2238",
    strokeWidth: 1.4232,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9785 59.945C74.3016 61.0472 76.9675 56.5498 75.6863 55.3713C74.4027 54.1928 73.5452 56.161 73.5452 56.161L73.3136 57.5708L72.9662 59.4701L72.8751 59.8958L72.9785 59.945Z",
    fill: "#D39563"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.147 56.8819C75.147 56.8819 74.5951 55.7379 73.3878 57.7824",
    stroke: "#1C2238",
    strokeWidth: 1.4232,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1726 55.3047C60.1726 55.3047 62.6241 51.3117 61.9416 47.267C61.9416 47.267 60.2539 48.3692 59.6823 51.2182C59.1082 54.0648 60.1726 55.3047 60.1726 55.3047Z",
    fill: "#13223D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9185 55.3836C73.9185 55.3836 70.8707 51.0412 71.5532 46.9965C71.5532 46.9965 73.4307 48.3718 74.0023 51.2184C74.5714 54.0649 73.9185 55.3836 73.9185 55.3836Z",
    fill: "#13223D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M72.721 46.8193C72.721 46.8193 66.4973 54.2494 59.6798 51.2183C59.6798 51.2183 58.1695 45.2964 66.3692 44.7625L72.721 46.8193Z",
    fill: "#13223D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M68.214 45.7072C69.4903 46.0614 69.6578 52.4754 75.2039 52.5812L73.1367 46.4969L68.214 45.7072Z",
    fill: "#13223D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6827 53.7628L61.5484 54.2598C61.5484 54.2598 61.881 53.1649 63.5688 52.978C65.259 52.7861 65.6827 53.7628 65.6827 53.7628Z",
    fill: "#1C2238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0639 53.7623L72.1982 54.2593C72.1982 54.2593 71.8656 53.1645 70.1779 52.9775C68.4877 52.7856 68.0639 53.7623 68.0639 53.7623Z",
    fill: "#1C2238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4738 60.1985L65.6688 59.6892C65.8609 59.6498 66.0728 59.6523 66.2847 59.699L66.8071 59.8147L67.253 59.672C67.455 59.608 67.731 59.6031 67.9256 59.6621L69.0516 60.1788L64.4738 60.1985Z",
    fill: "#DC587D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4734 60.1985C64.4734 60.1985 65.0623 61.7781 66.7968 61.7781C68.5338 61.7781 69.0512 60.1789 69.0512 60.1789L64.4734 60.1985Z",
    fill: "#DC587D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8379 60.2822C64.8379 60.2822 65.0966 60.9859 66.7991 60.9859C68.3489 60.9859 68.7702 60.265 68.7702 60.265L64.8379 60.2822Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8432 61.3652C65.9507 61.3652 66.0379 61.3056 66.0379 61.2322C66.0379 61.1587 65.9507 61.0991 65.8432 61.0991C65.7357 61.0991 65.6486 61.1587 65.6486 61.2322C65.6486 61.3056 65.7357 61.3652 65.8432 61.3652Z",
    fill: "#E0939C"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4952 57.4085V58.6535L67.2269 58.6658",
    stroke: "#1C2238",
    strokeWidth: 1.4001,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5875 56.0484C64.5875 56.0484 63.6118 55.361 62.6879 56.0484",
    stroke: "#1C2238",
    strokeWidth: 1.4232,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1832 56.0484C69.1832 56.0484 70.1589 55.361 71.0828 56.0484",
    stroke: "#1C2238",
    strokeWidth: 1.4232,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M65.6512 56.9045C66.0013 55.4164 65.077 53.9266 63.5868 53.577C62.0965 53.2274 60.6046 54.1504 60.2545 55.6385C59.9044 57.1266 60.8286 58.6164 62.3189 58.966C63.8092 59.3156 65.3011 58.3927 65.6512 56.9045Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M73.3949 56.9043C73.745 55.4162 72.8207 53.9265 71.3304 53.5769C69.8401 53.2273 68.3482 54.1502 67.9981 55.6383C67.648 57.1265 68.5723 58.6162 70.0626 58.9658C71.5528 59.3154 73.0448 58.3925 73.3949 56.9043Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6512 56.9045C66.0013 55.4164 65.077 53.9266 63.5868 53.577C62.0965 53.2274 60.6046 54.1504 60.2545 55.6385C59.9044 57.1266 60.8286 58.6164 62.3189 58.966C63.8092 59.3156 65.3011 58.3927 65.6512 56.9045Z",
    stroke: "#F2CF31",
    strokeWidth: 2.0556,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9797 57.9794C73.9267 56.7783 73.7193 55.0381 72.5165 54.0925C71.3137 53.1469 69.571 53.354 68.624 54.555C67.6771 55.7561 67.8844 57.4963 69.0872 58.4419C70.29 59.3875 72.0327 59.1804 72.9797 57.9794Z",
    stroke: "#F2CF31",
    strokeWidth: 2.0556,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7234 56.4982C65.7234 56.4982 66.7016 54.9949 68.0321 56.4982",
    stroke: "#F2CF31",
    strokeWidth: 2.0556,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M101.34 105.424L99.5224 102.431L104.969 99.8644L106.786 102.855L101.34 105.424Z",
    fill: "#E0A396"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M100.193 101.436L102.63 105.453C102.63 105.453 101.8 106.049 102.436 107.401C103.073 108.753 102.83 109.86 101.988 110.51L97.1547 102.549C97.1547 102.543 98.266 101.959 100.193 101.436Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M101.981 110.505L97.1483 102.542L96.579 102.886L101.412 110.849L101.981 110.505Z",
    fill: "#070924"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M98.686 101.908C98.686 101.908 99.4471 103.508 98.1998 104.263",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M102.179 106.231C102.179 106.231 102.028 105.979 101.351 105.708",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M102.232 106.892C102.232 106.892 101.928 106.447 101.404 106.387",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M111.477 77.1186C111.477 77.1186 114.554 88.5854 115.008 90.8481C115.459 93.108 116.365 97.6305 114.464 99.2604C112.563 100.887 105.255 104.792 105.255 104.792L102.57 99.9742L106.922 97.3618L111.477 77.1186Z",
    fill: "#1C3259"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M107.913 113.244H104.408L105.03 107.265H108.535L107.913 113.244Z",
    fill: "#E0A396"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.902 112.158H108.604C108.604 112.158 108.682 113.175 110.17 113.331C111.657 113.487 112.482 114.27 112.598 115.325H103.274C103.276 115.325 103.352 114.074 103.902 112.158Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M112.601 115.325H103.277V115.99H112.601V115.325Z",
    fill: "#070924"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M103.523 113.689C103.523 113.689 105.288 113.868 105.288 115.325",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M109.035 112.949C109.035 112.949 108.74 112.947 108.158 113.386",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M109.631 113.244C109.631 113.244 109.09 113.273 108.769 113.689",
    stroke: "#070924",
    strokeWidth: 0.8073,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.52 81.0487L111.476 77.1186L105.688 77.1504C102.794 79.0634 103.85 85.3228 103.85 85.3228C104.194 88.6981 105.115 91.796 105.178 94.5644L103.676 109.612H109.062L111.635 96.2694C111.745 95.6597 111.794 95.0384 111.782 94.4171L111.583 83.0456L112.52 81.0487Z",
    fill: "#233E80"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M111.672 71.6424L116.375 71.7638C117.199 71.6858 117.885 71.102 118.091 70.2986C118.38 69.1716 118.424 68.3451 117.272 68.1775L111.877 67.4782L111.672 71.6424Z",
    fill: "#EABA8F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M108.069 71.7609C108.069 71.7609 110.051 72.6509 113.121 72.7781L113.35 67.481L108.303 66.8626L108.069 71.7609Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M114.972 69.3074L119.067 60.4559L120.919 60.7536L117.979 70.6339C117.328 72.0152 115.415 72.1568 114.567 70.8853C114.179 70.3015 114.659 69.9374 114.972 69.3074Z",
    fill: "#EABA8F"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M118.724 61.7766L117.971 60.245C117.835 59.9676 117.705 59.6844 117.806 59.3925L118.272 58.1267C118.347 57.91 118.66 57.6442 118.97 57.8522C119.094 57.936 119.181 58.0603 119.169 58.2106L119.117 59.0688L119.54 59.6844L122.037 59.6468C122.037 59.6468 122.037 60.8374 120.576 61.9298L119.598 62.1523L118.724 61.7766Z",
    fill: "#EABA8F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M123.172 55.2716L122.084 60.8085C122.058 60.9587 121.916 61.0599 121.766 61.0426L119.002 60.7016C118.837 60.6813 118.724 60.5253 118.756 60.3606L119.839 54.8641C119.867 54.7196 120.003 54.6185 120.151 54.6329L122.924 54.9364C123.088 54.9508 123.204 55.1069 123.172 55.2716Z",
    fill: "#13223D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M122.55 55.6155L121.757 60.0629C121.739 60.1669 121.647 60.2421 121.54 60.2334L119.485 60.0831C119.363 60.0745 119.276 59.9618 119.3 59.8404L120.2 55.2976C120.22 55.1935 120.318 55.1213 120.425 55.1358L122.373 55.3814C122.489 55.3958 122.57 55.5028 122.55 55.6155Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M107.786 66.6401C107.786 66.6401 111.16 67.3221 111.988 70.1541C112.239 71.0153 111.475 77.1186 111.475 77.1186L105.687 77.1504C105.687 77.1504 104.709 75.1882 103.662 73.2694C102.611 71.3476 102.568 68.4405 105.132 67.4839L107.786 66.6401Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M111.933 72.7781C111.933 72.7781 112.289 70.1831 111.244 68.8566",
    stroke: "#ECECF6",
    strokeWidth: 1.0667,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M103.386 76.451L102.046 87.0046L100.214 86.8168C100.214 86.8168 99.6032 78.76 100.141 75.9019C100.425 74.4021 102.254 73.7981 103.388 74.8211C103.909 75.2951 103.533 75.7661 103.386 76.451Z",
    fill: "#EABA8F"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M102.553 88.6778C102.605 88.8946 102.533 89.1373 102.377 89.2789C102.163 89.4725 101.873 89.4147 101.752 89.1517L101.65 88.9379C101.41 89.1084 101.071 89.565 101.37 91.007C101.419 91.2497 101.294 91.5127 101.092 91.5907C100.933 91.6543 100.773 91.585 100.687 91.4376C100.684 91.4318 100.681 91.4231 100.675 91.4145C100.634 91.5619 100.536 91.6861 100.409 91.7352C100.25 91.7988 100.09 91.7295 100.004 91.5821C99.992 91.5618 99.9833 91.5416 99.9747 91.5185C99.9283 91.5734 99.8734 91.6196 99.8097 91.6428C99.6505 91.7063 99.4914 91.637 99.4045 91.4896C99.3814 91.4492 99.3611 91.4 99.3524 91.348C99.3496 91.3278 99.3467 91.3104 99.3409 91.2931C99.3351 91.296 99.3293 91.3018 99.3206 91.3018C99.1614 91.3653 99.0023 91.296 98.9155 91.1486C98.8923 91.1081 98.872 91.059 98.8634 91.007C98.7823 90.6082 98.7389 90.2383 98.7331 89.9002C98.7331 89.9002 98.7331 89.8944 98.7331 89.8858C98.7302 89.7268 98.7389 89.5737 98.7534 89.4292C98.7968 88.7385 99.7518 87.834 100.218 86.8168L102.05 87.0046L102.553 88.6778Z",
    fill: "#EABA8F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M101.83 71.3216L100.357 75.1448C100.058 75.9164 100.278 76.792 100.906 77.3324C101.789 78.0925 102.513 78.4999 103.172 77.5405L105.514 73.1104L101.83 71.3216Z",
    fill: "#EABA8F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M104.466 67.8105C104.466 67.8105 102.165 69.2698 100.9 72.7145L105.117 74.8472L107.75 71.3505L104.466 67.8105Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M104.683 74.5958L106.46 71.7609",
    stroke: "#ECECF6",
    strokeWidth: 1.0667,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8187 62.6666C101.173 62.681 102.279 61.8257 102.29 60.7506C102.302 59.6785 101.217 58.7942 99.8621 58.7798C98.5077 58.7653 97.4022 59.6207 97.3906 60.6957C97.3762 61.7679 98.4643 62.6521 99.8187 62.6666Z",
    fill: "#DF7658"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M101.233 61.7939C101.809 62.3834 102.756 62.395 103.346 61.817C103.936 61.242 103.948 60.297 103.369 59.7075C102.793 59.1179 101.847 59.1064 101.257 59.6843C100.666 60.2594 100.655 61.2044 101.233 61.7939Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M108.055 64.1086L108.327 67.7353L105.355 67.5301L104.973 62.3574L108.055 64.1086Z",
    fill: "#EABA8F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M108.22 66.3049C108.214 66.2413 106.663 64.493 106.663 64.493L108.104 64.5363L108.22 66.3049Z",
    fill: "#1F120B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M106.145 57.2684C106.145 57.2684 107.734 56.7829 108.732 58.5891C108.732 58.5891 109.441 59.9039 110.446 61.8054C110.975 62.8111 110.463 64.0942 109.36 64.3687C108.683 64.5363 107.879 64.623 107.045 64.4554L105.801 64.0826C102.716 62.8516 102.771 58.4099 105.914 57.3436C105.989 57.3176 106.067 57.2915 106.145 57.2684Z",
    fill: "#EABA8F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M109.334 60.4067L110.396 60.7939C110.587 60.8402 110.671 61.1089 110.552 61.1841L109.921 61.5858L109.334 60.4067Z",
    fill: "#EABA8F"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M105.835 61.5453C105.835 61.5453 103.132 57.4533 107.913 57.3522C107.913 57.3522 104.793 55.6963 102.125 58.8693C101.566 59.534 101.294 60.7622 101.508 61.6031C102.029 63.6607 103.667 63.2763 105.198 65.0622C105.198 65.0622 106.093 64.4091 105.745 62.9122C105.667 62.5596 105.835 61.5453 105.835 61.5453Z",
    fill: "#DF7658"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M106.391 58.4156C107.088 61.5858 106.176 62.236 106.176 62.236L104.2 59.6091L106.391 58.4156Z",
    fill: "#DF7658"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M104.278 62.4903C104.503 63.0509 105.14 63.3254 105.701 63.1C106.263 62.8746 106.538 62.2389 106.312 61.6782C106.086 61.1176 105.45 60.8431 104.888 61.0685C104.327 61.2939 104.055 61.9297 104.278 62.4903Z",
    fill: "#EABA8F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M105.828 62.1088C105.828 62.1088 105.533 61.3719 104.876 61.7707",
    stroke: "#0E1921",
    strokeWidth: 0.5755,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M108.22 59.5282C108.22 59.5282 108.712 59.2046 108.86 59.4242C108.86 59.4242 108.955 59.5745 108.521 59.849C108.087 60.1235 107.945 60.1524 107.812 60.0311C107.682 59.9126 107.977 59.6612 108.22 59.5282Z",
    fill: "#1F120B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M108.834 60.7795C108.865 60.9153 109.001 61.002 109.135 60.9702C109.268 60.9385 109.349 60.8026 109.314 60.6668C109.282 60.531 109.146 60.4443 109.013 60.4761C108.88 60.505 108.799 60.6408 108.834 60.7795Z",
    fill: "#1F120B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M109.971 61.999C109.971 61.999 109.806 62.355 109.155 62.2421",
    stroke: "#0E1921",
    strokeWidth: 0.5755,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M104.359 57.2106C104.359 57.2106 106.651 55.1357 108.955 57.988L104.686 60.2681L104.359 57.2106Z",
    fill: "#DF7658"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M106.645 66.802L105.355 67.5302L109.206 68.4145C109.363 68.1255 107.919 66.3049 107.919 66.3049L106.645 66.802Z",
    fill: "#EABA8F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6817 107.077L36.2252 105.921C37.623 105.716 38.7835 105.872 39.4318 106.982C39.4636 107.037 39.4954 107.098 39.5273 107.158C40.4244 108.956 39.5446 111.14 37.6983 111.941L32.3415 114.256H22.0042L22.7305 107.82L31.6817 107.077Z",
    fill: "#1C3259"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9867 114.264L29.4729 113.834L30.3874 112.791C30.4742 112.689 30.5957 112.634 30.7231 112.64L35.6457 112.773C36.4705 112.799 37.1159 113.585 37.0233 114.504C36.9423 115.305 36.2766 115.886 35.5358 115.877L35.2551 115.874C33.1598 115.886 28.9519 115.906 28.9867 115.868C29.033 115.819 28.9867 114.264 28.9867 114.264Z",
    fill: "#070924"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M15.449 109.964C15.449 109.964 30.4948 112.178 30.5498 112.343C30.6048 112.507 29.4675 115.995 29.4675 115.995H15.449C15.449 115.995 11.4147 115.654 11.9675 112.291C11.9675 112.293 12.5318 110.091 15.449 109.964Z",
    fill: "#233E80"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5174 91.77C24.5174 91.77 22.3788 92.3508 21.6726 95.9197C20.9665 99.4887 20.1012 102.951 20.1012 102.951L15.2914 106.82L18.8886 107.967L23.9068 104.393L26.4188 97.2751L24.5174 91.77Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2934 91.2325L31.879 91.9722C33.0424 92.3277 33.7659 93.4807 33.5836 94.68L31.6851 107.077L22.734 107.82L22.9597 94.0847C22.9424 92.7958 23.9263 91.7151 25.2113 91.611L28.2934 91.2325Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2607 96.2174L22.8353 105.153",
    stroke: "#ECECF6",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 112.149L29.1617 110.048C29.3585 109.97 29.4858 109.773 29.4742 109.56C29.4627 109.328 29.2919 109.138 29.0662 109.097L21.7473 107.785L14.8422 110.297L23.9062 112.149Z",
    fill: "#EBEBEB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9715 105.777L19.8287 106.231C19.574 106.242 19.3425 106.387 19.2209 106.612L18.4106 108.106C18.1733 108.545 18.4859 109.077 18.9865 109.083C19.2412 109.086 19.4756 108.944 19.5885 108.716L19.9618 107.964C19.9618 107.964 22.1583 109.326 23.2609 107.58L22.9715 105.777Z",
    fill: "#D39563"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9714 105.777L24.948 105.037L25.7091 107.054L23.2608 107.577L22.9714 105.777Z",
    fill: "#D39563"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6652 106.915L23.9065 112.149L14.8396 110.294L11.0108 104.843C10.8517 104.618 11.0542 104.318 11.3234 104.375L19.6697 106.207C20.0835 106.297 20.4424 106.554 20.6652 106.915Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0561 92.0618C32.0561 92.0618 35.0774 93.1628 35.0166 96.4052C34.9703 98.8095 34.5391 103.555 34.3597 105.537C34.2989 106.21 33.8272 106.777 33.176 106.959L24.7024 107.603L23.4841 105.153L30.4065 103.292L30.5425 95.6221L32.0561 92.0618Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4838 105.153L30.4033 103.295L30.5191 97.7057",
    stroke: "#ECECF6",
    strokeWidth: 1.0551,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5534 88.8599C23.866 87.4555 24.1351 85.554 24.0888 84.7361C24.0772 84.5339 24.0888 84.7361 24.0888 84.7361L26.4995 83.3201C26.4995 83.3201 27.5674 86.4787 27.7381 88.5912L29.2951 88.3513L28.8726 83.8721L28.2533 80.5835C32.218 80.8667 33.2714 85.4384 33.2714 85.4384C33.8502 88.4496 33.8763 89.7731 32.0704 90.2933C32.0704 90.2933 32.0444 90.2991 31.9981 90.3106C31.9171 90.3308 31.8418 90.354 31.755 90.3742C31.6161 90.4031 31.4887 90.4262 31.3672 90.4435C30.2993 90.6487 28.152 90.9782 25.8223 90.8886C25.7876 90.8886 25.7529 90.8857 25.7181 90.8857C25.7037 90.8857 25.6892 90.8857 25.6747 90.8828C24.4824 90.8019 23.2785 90.091 23.5534 88.8599Z",
    fill: "#13223D"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0856 84.739C24.2217 86.9439 26.0622 88.1374 28.3196 87.9958C30.5769 87.8542 32.0875 86.5162 31.9515 84.3084C31.8155 82.1035 29.8736 80.4592 27.6163 80.569C24.5053 80.7164 23.9496 82.5312 24.0856 84.739Z",
    fill: "#13223D"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3608 86.2532C26.4216 86.8427 26.0077 87.3687 25.4376 87.4294C24.8675 87.4901 24.3553 87.0653 24.2945 86.4757C24.2337 85.8862 24.6476 85.3603 25.2177 85.2996C25.7849 85.236 26.2971 85.6637 26.3608 86.2532Z",
    fill: "#C27F49"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8239 88.7818L26.9455 92.1629C26.9773 93.0617 27.504 92.6947 28.3606 92.6542C29.0928 92.6195 30.1607 92.8507 30.0999 92.0589L29.66 87.0682L26.8239 88.7818Z",
    fill: "#D39563"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8992 90.8712L29.498 88.6807C29.6745 87.9351 26.8239 88.8194 26.8239 88.8194L26.8992 90.8712Z",
    fill: "#1F120B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6198 89.4985C26.1583 89.5563 24.9081 88.4119 24.8184 87.1808L24.6274 84.2794C24.5174 82.7392 25.6113 81.3867 27.1017 81.2278C28.6269 81.0631 30.2649 82.1757 30.4269 83.7477L30.5572 86.0827C30.6556 87.8917 29.3648 89.3106 27.6198 89.4985Z",
    fill: "#D39563"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3951 86.5538L26.3198 87.2965H26.6816",
    stroke: "#040906",
    strokeWidth: 0.5144,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9113 84.8575C27.9113 84.8575 27.3094 84.8286 27.3123 85.08C27.3123 85.08 27.3181 85.2505 27.8419 85.2649C28.3657 85.2794 28.4988 85.236 28.5422 85.0742C28.5856 84.9124 28.192 84.8488 27.9113 84.8575Z",
    fill: "#040906"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4117 85.0195C25.4117 85.0195 25.9037 84.9501 25.9529 85.1842C25.9529 85.1842 25.9818 85.3431 25.5506 85.3952C25.1194 85.4472 24.9747 85.3952 24.9313 85.268C24.8792 85.1206 25.1773 85.031 25.4117 85.0195Z",
    fill: "#040906"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8261 86.2503C25.8348 86.3919 25.7306 86.5162 25.5917 86.5277C25.4528 86.5364 25.3341 86.4295 25.3225 86.285C25.3138 86.1434 25.418 86.0191 25.5569 86.0076C25.6958 85.9989 25.8174 86.1087 25.8261 86.2503Z",
    fill: "#040906"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0303 86.1521C28.039 86.2937 27.9348 86.418 27.7959 86.4295C27.657 86.4382 27.5383 86.3313 27.5268 86.1868C27.5181 86.0452 27.6223 85.9209 27.7612 85.9094C27.9001 85.9007 28.0216 86.0076 28.0303 86.1521Z",
    fill: "#040906"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2618 87.7675L27.8651 87.7155C27.8651 87.7155 27.7724 88.2356 26.9448 88.2183C26.3254 88.2067 26.2618 87.7675 26.2618 87.7675Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0754 83.5888C29.0956 83.7015 29.1159 85.5655 30.2011 86.1579C30.8378 86.5047 31.4832 84.0368 31.4832 84.0368L29.0754 83.5888Z",
    fill: "#13223D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8995 85.9816C31.9602 86.5653 31.5522 87.0855 30.985 87.1462C30.4206 87.2069 29.9142 86.785 29.8534 86.2012C29.7926 85.6175 30.2007 85.0973 30.7679 85.0366C31.3322 84.9788 31.8387 85.4007 31.8995 85.9816Z",
    fill: "#D39563"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5506 86.4469C30.5506 86.4469 30.4724 85.6811 31.193 85.7273",
    stroke: "#040906",
    strokeWidth: 0.5144,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6445 82.1327C24.6445 82.1327 25.9526 85.1843 30.2993 84.3289C30.2993 84.3289 31.5466 84.7538 31.2515 83.5834C30.9563 82.413 28.7105 80.8149 28.7105 80.8149L26.6703 81.0577L24.6445 82.1327Z",
    fill: "#13223D"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7455 81.6613C26.7455 81.6613 24.5055 82.3866 24.63 84.2794L24.3348 83.112L25.0351 81.7942L25.3708 81.4301L26.1985 81.1093L26.7455 81.6613Z",
    fill: "#13223D"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6486 91.556C25.6486 91.556 29.0432 90.9752 31.5321 91.8999C31.5321 91.8999 31.2253 93.6829 28.2184 93.7349C27.6541 93.7436 27.0869 93.6598 26.5689 93.4402C25.8685 93.1425 25.1016 92.5675 25.6486 91.556Z",
    fill: "#D39563"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M64.726 31.4621L72.7482 24.2L76.3454 27.0233L68.2248 36.921C66.2222 39.045 61.8957 39.5305 60.304 37.0857C60.0783 36.7418 60.2924 36.2823 60.0782 35.8431L64.726 31.4621Z",
    fill: "#3962B2"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6262 36.5395L75.4052 36.5452L73.9293 30.6471L77.1503 30.6385L78.6262 36.5395Z",
    fill: "#E0A396"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9403 35.5482L79.261 35.5396C79.261 35.5396 79.3363 36.473 80.7022 36.6146C82.0711 36.7562 82.8264 37.4728 82.9364 38.4438L74.3731 38.4612C74.3731 38.4583 74.4396 37.3081 74.9403 35.5482Z",
    fill: "#070924"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9353 38.4409L74.3719 38.4587L74.3732 39.0684L82.9365 39.0506L82.9353 38.4409Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5956 36.9556C74.5956 36.9556 76.2191 37.1175 76.222 38.4554",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6601 36.265C79.6601 36.265 79.3909 36.2621 78.8556 36.6667",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2065 36.5366C80.2065 36.5366 79.7088 36.5655 79.4136 36.9469",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6636 26.1766L73.6113 34.2594L78.641 33.6006L76.8526 26.0379C76.514 23.8879 75.4634 23.5989 74.6387 23.5787C72.5174 23.5238 71.6636 26.1766 71.6636 26.1766Z",
    fill: "#3962B2"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1808 44.3941L79.99 46.7522L75.7909 42.5995L77.9787 40.2414L82.1808 44.3941Z",
    fill: "#E0A396"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9433 46.4141L81.8778 43.2498C81.8778 43.2498 82.6129 43.8306 83.6489 42.929C84.685 42.0245 85.7239 41.9609 86.5111 42.5389L80.6912 48.8127C80.6912 48.8127 79.8925 47.9804 78.9433 46.4141Z",
    fill: "#070924"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5113 42.537L80.6916 48.81L81.1396 49.2244L86.9592 42.9514L86.5113 42.537Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7433 47.6249C79.7433 47.6249 80.9674 46.547 81.9485 47.4573",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M82.682 43.4521C82.682 43.4521 82.4968 43.6486 82.4302 44.3132",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2526 43.2382C83.2526 43.2382 82.9343 43.6196 83.0124 44.0964",
    stroke: "white",
    strokeWidth: 0.7415,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9301 34.1121L81.1593 41.6025L76.9775 45.6222L68.1103 36.9383L73.9301 34.1121Z",
    fill: "#3963DA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4288 32.7625L58.4613 34.4791C58.3572 35.1958 58.5337 35.8575 58.8376 36.4355C59.6334 37.9469 61.2569 39.1577 62.9644 39.045H71.8432C72.966 39.045 73.9905 38.3977 74.4709 37.3863C75.3536 35.531 74.0773 33.3723 72.0255 33.2423L64.4288 32.7625Z",
    fill: "#3963DA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M65.059 17.9724L63.6323 20.8911L60.9785 19.348L63.1316 15.0103L65.059 17.9724Z",
    fill: "#EABA8F"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2199 19.6919C64.246 19.6399 63.945 17.7152 63.945 17.7152L64.8971 18.3077L64.2199 19.6919Z",
    fill: "#1F120B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7075 11.7448C66.7075 11.7448 68.1255 12.1725 67.9693 14.0047C67.9693 14.0047 67.8419 15.3311 67.6393 17.2384C67.5323 18.2469 66.5165 18.9434 65.5615 18.5995C64.9769 18.3885 64.3373 18.0533 63.8019 17.5158L63.0639 16.6228C61.3912 14.1838 63.6398 10.9155 66.4991 11.6841C66.5686 11.7015 66.638 11.7217 66.7075 11.7448Z",
    fill: "#EABA8F"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6059 15.4786L68.1847 16.1895C68.2657 16.2877 68.1934 16.4322 68.066 16.4293L67.3975 16.4149L67.6059 15.4786Z",
    fill: "#EABA8F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1236 12.6551C61.3523 11.9153 62.2002 11.164 62.9382 10.9357C66.1129 9.95314 67.7451 12.5424 67.7451 12.5424C62.9556 10.6669 64.3562 14.7618 64.3562 14.7618C64.3562 14.7618 63.7282 15.4322 63.6125 15.727C63.0887 17.065 62.2118 16.9465 62.2118 16.9465C61.3725 14.8803 60.7532 13.8486 61.1236 12.6551Z",
    fill: "#13223E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1365 14.0047C67.1365 14.0047 67.6285 13.9903 67.6371 14.2099C67.6371 14.2099 67.64 14.3602 67.2088 14.363C66.7776 14.3659 66.6677 14.3255 66.6242 14.1839C66.5837 14.0423 66.905 13.9931 67.1365 14.0047Z",
    fill: "black"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1068 15.4468C67.1271 15.5595 67.2371 15.6346 67.3499 15.6144C67.4628 15.5942 67.5381 15.4843 67.5178 15.3716C67.4975 15.2589 67.3876 15.1838 67.2747 15.204C67.1618 15.2272 67.0866 15.3341 67.1068 15.4468Z",
    fill: "black"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4618 16.3571L67.3068 16.8541C67.3068 16.8541 67.1766 17.2009 66.7714 16.9813C66.3663 16.7616 66.4618 16.3571 66.4618 16.3571Z",
    fill: "#FDFDFF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4077 15.3254C64.8736 15.2444 65.2035 14.8283 65.1775 14.3573L65.0964 12.9384C65.0964 12.9384 66.7576 14.0163 67.1714 12.6349C67.1714 12.6349 69.3246 13.1464 69.3506 11.7304C69.3738 10.3115 68.0541 10.326 65.163 10.2711C65.163 10.2711 65.5595 9.66709 65.0964 9.53993C64.6334 9.41278 63.9736 10.2133 63.9736 10.2133C63.9736 10.2133 63.7421 9.43879 63.2819 9.56305C62.8247 9.68731 62.7378 10.2913 62.7378 10.2913C62.7378 10.2913 59.2969 10.6872 60.8047 14.1723L62.2111 16.9465L63.7247 14.9641L64.4077 15.3254Z",
    fill: "#13223E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6626 15.0277C62.5497 15.5537 62.8855 16.0738 63.4151 16.1866C63.9418 16.2993 64.4627 15.964 64.5755 15.4352C64.6884 14.9093 64.3527 14.3891 63.8231 14.2764C63.2935 14.1666 62.7755 14.5018 62.6626 15.0277Z",
    fill: "#EABA8F"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9999 15.5132C63.9999 15.5132 64.1475 14.8226 63.4616 14.7908",
    stroke: "black",
    strokeWidth: 0.5256,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M63.994 20.5761C63.994 20.5761 64.4628 22.1482 64.159 25.0149C63.8522 27.8816 65.331 30.8899 65.331 30.8899C65.331 30.8899 65.3629 35.3229 57.9629 35.5396C57.9629 35.5396 56.2381 28.9942 57.0947 24.1306C57.879 19.6803 61.265 19.0474 61.265 19.0474L63.994 20.5761Z",
    fill: "#FDFDFF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M62.246 20.1976L71.3273 22.5817L71.0437 26.2951L61.5775 25.6651L62.246 20.1976Z",
    fill: "#FDFDFF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6875 25.8735L61.5765 25.6651",
    stroke: "#ECECF6",
    strokeWidth: 0.9785,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3254 22.5817L76.0657 19.374L78.1263 20.3306L71.0418 26.2951L71.3254 22.5817Z",
    fill: "#EABA8F"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5699 19.53L75.0637 19.689C74.7396 19.7092 74.4965 19.4664 74.5196 19.1457L74.9248 13.8111C74.9479 13.4903 75.2315 13.2129 75.5557 13.1926L78.0619 13.0337C78.386 13.0135 78.6291 13.2562 78.6059 13.577L78.2008 18.9116C78.1776 19.2353 77.894 19.5098 77.5699 19.53Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8004 20.3508C77.8306 20.7553 78.6351 20.2352 79.0374 19.2093C79.4426 18.1805 79.2921 17.0332 78.2618 16.6287C77.2316 16.2241 76.0711 16.7298 75.6659 17.7586C75.2636 18.7874 75.7701 19.9462 76.8004 20.3508Z",
    fill: "#EABA8F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5699 19.53L75.0637 19.689C74.7396 19.7092 74.4965 19.4664 74.5196 19.1457L74.9248 13.8111C74.9479 13.4903 75.2315 13.2129 75.5557 13.1926L78.0619 13.0337C78.386 13.0135 78.6291 13.2562 78.6059 13.577L78.2008 18.9116C78.1776 19.2353 77.894 19.5098 77.5699 19.53Z",
    fill: "black"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8004 20.3508C77.8306 20.7553 78.6351 20.2352 79.0374 19.2093C79.4426 18.1805 79.2921 17.0332 78.2618 16.6287C77.2316 16.2241 76.0711 16.7298 75.6659 17.7586C75.2636 18.7874 75.7701 19.9462 76.8004 20.3508Z",
    fill: "#EABA8F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_309:3861"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_309:3861",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABrkAAAOVCAYAAADdnovPAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSharingIcon);
export default __webpack_public_path__ + "static/media/content-sharing-icon.58dd7340bf519cff8fde1ba4590c3d82.svg";
export { ForwardRef as ReactComponent };